import { httpRequest } from "@services/http";
import { Debit } from "@models/debit.model";
import { DebitSerializer } from "@models/serializers/debitSerializer";

export class CommandListDebits {
  async run(
    contractId: number,
    params?: { reporter?: string; source_type?: string },
  ): Promise<Debit[]> {
    const query = new URLSearchParams();
    if (params?.reporter) query.set("reporter", params.reporter);
    if (params?.source_type) query.set("source_type", params.source_type);
    const qs = query.toString();
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/contracts/${contractId}/debits/${qs ? `?${qs}` : ""}`;
    const response = await httpRequest<any[]>(url, { method: "GET" });
    return DebitSerializer.fromJsonList(response);
  }
}
